import { Cabin, Departure } from '@/data.ts'
import { discountedCabinPrice } from '@/lib/discount.ts'

const DEFAULT_OCCUPANCY = 2

export function calculateCabinPrice (cabin: Cabin, occupancy: number): number {
  if (occupancy < DEFAULT_OCCUPANCY) {
    return cabin.surcharge_price ?? cabin.unit_price
  }
  if (occupancy > DEFAULT_OCCUPANCY) {
    return cabin.discount_price ?? cabin.unit_price
  }
  return cabin.unit_price
}

export function baseCabinPrice (cabin: Cabin): number {
  if (cabin.maximum_occupancy < DEFAULT_OCCUPANCY) {
    return cabin.surcharge_price ?? cabin.unit_price
  }
  if (cabin.minimum_occupancy > DEFAULT_OCCUPANCY) {
    return cabin.discount_price ?? cabin.unit_price
  }
  return cabin.unit_price
}

export function applyDiscount (departure: Departure, price: number): number {
  if (departure.discount == null) {
    return price
  }
  return discountedCabinPrice(price, departure.discount)
}

export function cheapestCabinPrice (departure: Departure): number {
  const prices = departure.cabins.map(cabin => baseCabinPrice(cabin))
  return Math.min(...prices)
}

export interface DepartureGroup {
  previous_end_date?: string
  previous_start_date?: string
  start_date: string
  end_date: string
  next_start_date?: string
  status: Departure['status']
  departures: Departure[]
  index: number
}

export function groupDeparturesByStatus (departures: Departure[]): DepartureGroup[] {
  let currentGroup: DepartureGroup | null = null
  const groups: DepartureGroup[] = []
  for (const departure of departures) {
    if (currentGroup == null || currentGroup?.status !== departure.status) {
      const newGroup: DepartureGroup = {
        previous_end_date: currentGroup?.end_date,
        previous_start_date: currentGroup?.departures?.at(-1)?.start_date,
        status: departure.status,
        start_date: departure.start_date,
        end_date: departure.end_date,
        departures: [departure],
        index: (currentGroup?.index ?? 0) + (currentGroup?.status === 'fully_booked' ? 1 : (currentGroup?.departures?.length ?? 0))
      }
      if (currentGroup != null) {
        currentGroup.next_start_date = newGroup.start_date
      }
      currentGroup = newGroup
      groups.push(currentGroup)
    } else {
      currentGroup.departures.push(departure)
    }
  }
  console.log({ groups })
  return groups
}
